<template>
  <div>
    <div class="modal-user modal-xl">
      <div style="text-align: right" class="modal-close" @click="closeModal">
        &#10006;
      </div>
      <div class="title">
        <h3 class="modal-title text-center">Add Regimen</h3>
      </div>
      <div class="body modal-scroll">
        <div class="row">
          <div class="col-md-6">
            <div class="d-flex mb-3">
              <label class="typo__label admin-label mt-3">Select user</label>
              <multiselect
                v-model="form.selectedUser"
                :options="getEmail"
                :searchable="false"
                :close-on-select="false"
                :show-labels="false"
                :custom-label="customLabel"
                track-by="id"
                placeholder="Pick a value"
              />
              <has-erroron save regimen body :form="form" field="email" />
            </div>

            <div class="form-group d-flex mb-3">
              <label class="col-form-label admin-label text-md-start"
                >Goal</label
              >
              <div class="w-100 d-flex gap-3">
                <select
                  class="form-select custom-select shadow-none"
                  aria-label="Default select example"
                  v-model="form.goal"
                >
                  <option value="Getting Started">Getting Started</option>
                  <option value="Moisture">Moisture</option>
                  <option value="Growth - Stop Breakage">
                    Growth - Stop Breakage
                  </option>
                  <option value="Growth - Retain Length">
                    Growth - Retain Length
                  </option>
                  <option value="Definition">Definition</option>
                  <option value="Other">Other</option>
                </select>
                <input
                  v-if="form.goal === 'Other'"
                  type="text"
                  class="form-control"
                  placeholder="Enter your goal"
                />
              </div>
            </div>

            <div class="form-group d-flex mb-3">
              <label class="col-form-label admin-label text-md-start"
                >Stage</label
              >
              <select
                class="form-select custom-select shadow-none"
                aria-label="Default select example"
                v-model="form.stage"
              >
                <option value="Onboard">Onboard</option>
              </select>
            </div>
            <div class="form-group d-flex mb-3">
              <label class="col-form-label text-md-start admin-label"
                >Method</label
              >
              <multiselect
                v-model="form.method"
                :options="getMethodName"
                tag-placeholder="Add this as new tag"
                placeholder="Add a tag"
                label="value"
                track-by="value"
                @tag="addTag"
              />
              <has-erroron save regimen body :form="form" field="email" />
            </div>
            <div class="d-flex mb-3">
              <label class="typo__label admin-label">Elements</label>
              <multiselect
                v-model="form.elements"
                :options="getElementName"
                :multiple="true"
                :taggable="true"
                tag-placeholder="Add this as new tag"
                placeholder="Add a tag"
                label="value"
                track-by="value"
                @tag="addTag"
              />
              <has-error :form="form" field="nameRegimen" />
            </div>
          </div>

          <div class="col-md-6">
            <div class="d-flex">
              <label class="typo__label mt-3 admin-label"
                >Select <br />products</label
              >
              <multiselect
                v-model="form.products"
                :options="getProductsName"
                :multiple="true"
                :taggable="true"
                tag-placeholder="Add this as new tag"
                placeholder="Search or add a tag"
                label="name"
                track-by="name"
                @tag="addTag"
              />
              <has-error :form="form" field="nameProducts" />
            </div>

            <div class="form-group d-flex mb-3">
              <label class="col-form-label admin-label text-md-start"
                >Next Review</label
              >
              <input
                v-model="form.review"
                class="form-control"
                type="text"
                name="title"
                placeholder="Next review"
              />
              <has-error :form="form" field="title" />
            </div>
            <div
              style="margin-left: auto; margin-right: auto"
              class="col-sm-12 d-block justify-content-center"
            >
              <div
                class="week-counter d-flex gap-5 justify-content-center mt-5"
              >
                <div class="minus-button" @click="decreaseWeekCount">
                  <MinusSvg />
                </div>
                <div class="counter d-flex align-items-center">
                  <div>
                    <h3 class="m-0">{{ form.weeks }}</h3>
                  </div>
                </div>
                <div class="plus-button" @click="increaseWeekCount">
                  <PlusSvg />
                </div>
              </div>
              <div class="d-flex mt-2">
                <span class="mt-2 mb-3 frequency"
                  >Adjust the length of time until the next check in.</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="footer">
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click="submitRegimenData"
            >
              Add Regimen
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { mapActions, mapGetters } from "vuex";
import Multiselect from "vue-multiselect";
import axios from "axios";
import PlusSvg from "@/components/SVG/Plus";
import MinusSvg from "@/components/SVG/Minus";
import CheckboxWeek from "@/components/CheckboxWeek";
import Swal from "sweetalert2";
import Form from "vform";

export default {
  components: { PlusSvg, MinusSvg, CheckboxWeek, Multiselect },

  data() {
    return {
      form: new Form({
        goal: "",
        stage: "",
        method: "",
        review: "",
        selectedUser: "",
        products: [],
        weeks: 4,
        elements: [],
        user_id: "",
      }),
      show: false,
      methods: [],
      element: [],
      selectedMethodElements: "",
    };
  },

  computed: {
    ...mapGetters(["adminData", "allRegimenElements", "profile", "shop"]),

    getEmail() {
      return this.adminData
        ? this.adminData.map((user) => {
            return { id: user.id, email: user.email };
          })
        : "";
    },

    getElementName() {
      return this.element
        ? this.element.map((name) => {
            return {
              id: name.id,
              value: name.element_name,
            };
          })
        : "";
    },

    getMethodName() {
      return this.methods
        ? this.methods.map((name) => {
            return {
              id: name.id,
              value: name.method_name,
            };
          })
        : "";
    },

    getProductsName() {
      return this.shop && this.shop.products
        ? this.shop.products.map((product) => {
            return {
              id: product.id,
              name: product.name || "No title",
              tags: product.tags || [],
              image: product.images || "",
            };
          })
        : [];
    },
  },

  created() {
    this.getAllRegimen();
    this.getAllProducts();
    this.fetchMethods();
    this.calculateNextReviewDate();
    this.fetchUserData();
  },

  watch: {
    form: {
      deep: true,
      handler(newForm, oldForm) {
        if (newForm.method) {
          this.selectedMethodElements = newForm.method.id;
          this.fetchElement();
        }
      },
    },
  },
  methods: {
    ...mapActions([
      "fetchAllRegimenElements",
      "fetchElementData",
      "fetchShopProducts",
      "saveRegimenData",
      "fetchUser",
    ]),

    decreaseWeekCount() {
      if (this.form.weeks > 1) {
        this.form.weeks -= 1;
        this.calculateNextReviewDate();
      }
    },

    increaseWeekCount() {
      if (this.form.weeks < 12) {
        this.form.weeks += 1;
        this.calculateNextReviewDate();
      }
    },
    async fetchUserData() {
      try {
        const userDataResponse = await this.$store.dispatch("fetchUser")
        this.$set(this.form, 'user_id', userDataResponse.id);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },

    calculateNextReviewDate() {
      const currentDate = new Date();
      const nextReviewDate = new Date(
        currentDate.setDate(currentDate.getDate() + 7 * this.form.weeks)
      );

      const formattedDate = `${
        nextReviewDate.getMonth() + 1
      }/${nextReviewDate.getDate()}/${nextReviewDate.getFullYear()}`;

      this.form.review = formattedDate;
    },

    addTag(newTag) {
      this.form.regimens.push(newTag);
    },

    getAllRegimen() {
      this.fetchAllRegimenElements();
    },

    getAllProducts() {
      this.fetchShopProducts();
    },
    fetchMethods() {
      axios
        .get(`${process.env.API_URL}/getMethods`)
        .then((response) => {
          this.methods = response.data;
        })
        .catch((error) => {
          console.error("Error fetching methods:", error);
        });
    },

    fetchElement() {
      axios
        .get(
          `${process.env.API_URL}/getMethodsWithElements/${this.selectedMethodElements}`
        )
        .then((response) => {
          this.element = response.data.elements;
        })
        .catch((error) => {
          console.error("Error fetching methods:", error);
        });
    },

    customLabel(option) {
      return option.email;
    },

    closeModal: function () {
      window.addEventListener("click", (event) => {
        if (event.target.classList.contains("modal-close")) {
          this.$store.commit("HIDE_MODAL");
        }
      });
    },

    submitRegimenData() {
      this.saveRegimenData(this.form)
      
        .then(() => {
          this.$store.commit("HIDE_MODAL");
          Swal.fire(
            "Successfully!",
            "REgimen has been added successfully.",
            "success"
          ).then(() => {
            this.form.goal = "";
            this.form.elements = [];
            this.form.selectedUser = "";
            this.form.stage = "";
            this.form.review = "";
            this.form.method = "";
            this.form.products = [];
            this.form.weekCount = 1;
          });
        })
        .catch((error) => {
          console.log("API call error:", error);
        });
    },
  },
};
</script>
  
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
  <style>
.modal-title {
  color: #603975;
  font-family: "Poppins";
  font-size: 30px;
  font-weight: 700;
  margin-bottom: 20px;
  position: relative;
  top: -22px;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
.form-control {
  color: #212529;
  border-radius: 3px;
  border: 1px solid #603975;
  background: #faf8fb;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.5) inset;
  box-shadow: none;
  resize: none;
  padding: 12px;
}
span .multiselect__tags {
  border: 1px solid #603975 !important;
  padding: 12px !important;
  background-color: #faf8fb !important;
  width: 100px !important;
}

.form-select {
  border: 1px solid #603975 !important;
  border-radius: 5px;
  padding: 12px;
  background-color: #faf8fb;
}
.form-check-input[type="radio"] {
  border-radius: 5px;
}
.form-check-input {
  border: 1px solid #603975;
}
.form-check-label {
  color: #613975;
  font-size: 14px;
  font-weight: 500;
}
.select-day div {
  margin-right: 15px !important;
}
.counter h3 {
  color: #603975;
}
.form-check-input:checked {
  background-color: #603975;
  border-color: #603975;
}
.form-check-input {
  width: 18px;
  height: 18px;
}
.form-check-input:focus {
  border-color: #613975;
  outline: 0;
  box-shadow: none;
}
.form-control:focus {
  border-color: #613975;
  box-shadow: none;
}
.multiselect__placeholder {
  margin-bottom: 0;
}
.multiselect__select {
  top: 8px !important;
}
.frequency {
  color: #979797;
  font-size: 10px;
  font-style: italic;
  font-weight: 400;
  line-height: normal;
}
.multiselect__tag {
  max-width: 200px;
}
</style>


// WEBPACK FOOTER //
// src/components/modals/AdminModals/AddRegimenModal.vue